import React from 'react';
import { useParams } from 'react-router';
import {
  useApiWithErrors,
  ApiError,
  PageHeader,
  Layout,
  Gutter,
} from '@axiom/ui';
import type { Account } from '@axiom/validation';

import { MyBench } from '../MyBench/MyBench';
import { AccountLegacyApi } from '../../api/account-legacy-api';

export const BenchView = () => {
  const { accountId } = useParams();
  let account: Account | null = null;

  const [responseAccount] = useApiWithErrors(
    accountId ? AccountLegacyApi.readAccount(accountId) : undefined
  );

  if (responseAccount && !(responseAccount instanceof ApiError)) {
    account = responseAccount.data;
  }

  const benchName = `${account?.calculatedName ?? ''} bench`.trim();

  return account ? (
    <>
      <Gutter name="DIGITAL_BENCH_BODY" bottom="16px">
        <PageHeader name="DIGITAL_BENCH_ACCOUNT_TITLE">{benchName}</PageHeader>
      </Gutter>
      <MyBench account={account} />
    </>
  ) : (
    <Layout position="center">
      <PageHeader name="BENCH_UNKNOWN">Bench not found</PageHeader>
    </Layout>
  );
};
